import styled from 'styled-components';

export const Bubble = styled.div<{ emphasized: boolean }>`
  height: 31px;
  min-width: 10px;
  border-radius: 15.5px;
  background-color: ${(props) =>
    props.emphasized
      ? props.theme.palette.error.light
      : props.theme.palette.background.paper};
  text-align: left;
  color: ${({ theme }) => theme.palette.secondary.main};
  float: right;

  p {
    margin: 6px 0 0 12px;
    float: left;
    color: ${(props) =>
      props.emphasized
        ? props.theme.palette.secondary.main
        : props.theme.palette.text.primary};
  }
`;

export const Arrow = styled.div`
  float: right;
  margin: 6px 12px 0 8px;
`;
